const DEFAULT_TEAM_LOGO_BASE = "https://profitxinv.s3.us-west-2.amazonaws.com/global/public/teamlogos";

const TEAM_LOGO_BASE =
  process.env.VUE_APP_TEAM_LOGO_BASE && process.env.VUE_APP_TEAM_LOGO_BASE.trim() !== ""
    ? process.env.VUE_APP_TEAM_LOGO_BASE.replace(/\/$/, "")
    : DEFAULT_TEAM_LOGO_BASE;

export function buildTeamLogoUrl(teamId) {
  if (!teamId) {
    return "";
  }
  return `${TEAM_LOGO_BASE}/${teamId}.svg`;
}

export function resolveTeamLogoUrl({ teamLogo, teamId, fallbackTeamId } = {}) {
  if (teamLogo) {
    return teamLogo;
  }
  const resolvedId = teamId || fallbackTeamId;
  return buildTeamLogoUrl(resolvedId);
}

